document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.offertrigger').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      var modal = trigger.nextElementSibling;
      var overlay = modal.nextElementSibling;
      modal.classList.remove('hidden');
      overlay.classList.remove('\!hidden');
    });
  });
  document.querySelectorAll('.offercontent .closeoffer').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      var modal = trigger.closest('.offercontent');
      var overlay = modal.nextElementSibling;
      modal.classList.add('hidden');
      overlay.classList.add('\!hidden');
      // listen escape key, close modal if pressed
    });
  });
  document.querySelectorAll('.offeroverlay').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      var overlay = trigger;
      var modal = overlay.previousElementSibling;
      modal.classList.add('hidden');
      overlay.classList.add('\!hidden');
    });
  });
});


var gridContainers = document.querySelectorAll('.product-grid');
document.addEventListener('DOMContentLoaded', function () {
  gridContainers.forEach(productGrid => {
    console.log(productGrid)
    var soldOut = productGrid.querySelectorAll('.grid__item.grid__item--available-false')
    console.log(soldOut);
    if (soldOut.length > 0) {
      console.log(soldOut);
      soldOut.forEach(product => {
        productGrid.appendChild(product)
      });
    }
  });
});